import React from "react";
import {render} from "react-dom";
import LinkedProducts from "../LinkedProducts/LinkedProducts";
import ProductTile from "../ProductTile/ProductTile";
import productPageBaseUri from "../../utils/productPageBaseUri";

const createInstance = (complementaryProductsContainer) => {
  const renderSuccess = (complementaryProducts, parentProductCode, errorMessage) => {
    complementaryProductsContainer.classList.remove("hidden");

    render(
      <LinkedProducts title="You may also require" errorMessage={errorMessage} sliderWrapperId="pdp-complementary-product-slider">
        {complementaryProducts.map(product => (
           <ProductTile
             key={product.productId}
             className="pdp-related-product__product-tile"
             parentProductCode={parentProductCode}
             productCode={product.productId}
             href={`${productPageBaseUri}${product.seoFriendlyUrlPath}`}
             title={product.title}
             heroThumbnail={product.heroThumbnailUrlPath}
         />))}
      </LinkedProducts>,
      complementaryProductsContainer
    );
  };

  const destroy = () => {
    complementaryProductsContainer.parentNode.removeChild(complementaryProductsContainer);
  };

  return {renderSuccess, destroy};
};

export default createInstance;
